import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

// // // LIST ALL Companies Types
export const typeCreate = (params = '') => Http.post('/companies-types', params)
export const typesList = (params = '') => Http.get(`/companies-types${serialize(params)}`)
export const typeByID = (params = '') => Http.get(`/companies-types/${params}`)
export const typeUpdate = (params = '') => Http.put(`/companies-types/${params.id}`, params)
export const typeDestroy = (params = '') => Http.delete(`/companies-types/${params.id}`)

// // COMPANIES
// // // LIST ALL COMPANYS
export const companiesList = (params = '') => Http.get(`/company${serialize(params)}`)
// company_size and contact are default includes on the API; asking for them by name was a 422.
export const companiesByID = (params = '') =>
	Http.get(`/company/${params}?includes=country,country_state,country_city,company_type,industry_sectors,perks,users`)
export const myCompanyByID = (params = '') =>
	// Kept as a compatibility alias for callers that use the old service name.
	// The admin API does not expose /me/companies; that route belongs to the
	// user-facing API and caused a 404 when opening an admin company edit form.
	companiesByID(params)
export const newCompany = (params = '') => Http.post('/company', params)
export const updateCompany = (params = '') => Http.put(`/company/${params.id}`, params)
export const deleteCompanyByID = (params = '') => Http.delete(`/company/${params.id}`)

// // // LIST ALL Companies Sizes
export const sizeCreate = (params = '') => Http.post('/companies-sizes', params)
export const sizesList = (params = '') => Http.get(`/companies-sizes${serialize(params)}`)
export const sizeByID = (params = '') => Http.get(`/companies-sizes/${params}`)
export const sizeUpdate = (params = '') => Http.put(`/companies-sizes/${params.id}`, params)
export const sizeDestroy = (params = '') => Http.delete(`/companies-sizes/${params.id}`)

// // // LIST ALL Companies Stages
export const stageCreate = (params = '') => Http.post('/companies-stages', params)
export const stagesList = (params = '') => Http.get(`/companies-stages${serialize(params)}`)
export const stageByID = (params = '') => Http.get(`/companies-stages/${params}`)
export const stageUpdate = (params = '') => Http.put(`/companies-stages/${params.id}`, params)
export const stageDestroy = (params = '') => Http.delete(`/companies-stages/${params.id}`)

// // // LIST ALL Companies Roles
export const roleCreate = (params = '') => Http.post('/companies-roles', params)
export const rolesList = (params = '') => Http.get(`/companies-roles${serialize(params)}`)
export const roleByID = (params = '') => Http.get(`/companies-roles/${params}`)
export const roleUpdate = (params = '') => Http.put(`/companies-roles/${params.id}`, params)
export const roleDestroy = (params = '') => Http.delete(`/companies-roles/${params.id}`)

// // COMPANY USERS & ROLES
export const companyUsers = (companyId) => Http.get(`/company/${companyId}/users`)
export const companyRoles = () => Http.get('/company-roles')
export const associateUser = (companyId, params) => Http.post(`/company/${companyId}/associate-user`, params)
export const removeCompanyUser = (companyId, params) => Http.delete(`/company/${companyId}/remove-user`, { data: params })
export const updateCompanyUserRole = (companyId, companyUserId, params) => Http.put(`/company/${companyId}/users/${companyUserId}/roles`, params)
export const transferOwnership = (companyId, companyUserId) => Http.post(`/company/${companyId}/users/${companyUserId}/transfer-ownership`)
